import { CountertopOutlineIcon } from './CountertopOutlineIcon';

/**
 * author: Google
 * id 31920D18-0B33-4CE8-B5D9-7E879DB4E6AA
 * name countertop-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/countertop-outline.svg
 * tags
 * - Home Automation 
 */
export const KitchenCounterOutlineIcon = CountertopOutlineIcon;
export default KitchenCounterOutlineIcon